import React from "react";
import './InputCalendario.scss'
import { Calendar } from 'primereact/calendar';
const InputCalendario = ({ titulo, value, onChange, obligatorio = true, id, view, onltyTime,className,type="date" }) => {


    return (
        <div className={`InputCalendario ${className}`}>
            <div className="tituloContenedor">
                {
                    obligatorio ?
                        <>
                            <div className="obligatorio">*</div>
                        </> : null
                }
                <div className="titulo">{titulo}</div>
            </div>
            <input 
                type={type}
                id={id}
                className="calendario"
                hourFormat="24"
                timeOnly={onltyTime}
                value={value}
                onChange={onChange}
                dateFormat="dd/mm/yy"
                showIcon
                pt={{
                    input: {
                        root: { className: 'border-teal-500' }
                    },
                    dropdownButton: {
                        root: { className: 'colorNaranja' }
                    }
                }}
            />
        </div>
    )
}
export default InputCalendario